/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-return-bill-payment.reducer';

export const PharmacyReturnBillPaymentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyReturnBillPaymentEntity = useAppSelector(state => state.pharmacyReturnBillPayment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyReturnBillPaymentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillPayment.detail.title">PharmacyReturnBillPayment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillPayment.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillPaymentEntity.id}</dd>
          <dt>
            <span id="paymentMethod">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillPayment.paymentMethod">Payment Method</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillPaymentEntity.paymentMethod}</dd>
          <dt>
            <span id="transactionDetails">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillPayment.transactionDetails">Transaction Details</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillPaymentEntity.transactionDetails}</dd>
          <dt>
            <span id="paidAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillPayment.paidAmount">Paid Amount</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillPaymentEntity.paidAmount}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillPayment.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillPaymentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillPayment.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillPaymentEntity.cursor}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillPayment.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillPaymentEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillPayment.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillPaymentEntity.microSec}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillPayment.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillPaymentEntity.lastUpdated}</dd>
          <dt>
            <span id="paymentStatus">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillPayment.paymentStatus">Payment Status</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillPaymentEntity.paymentStatus}</dd>
          <dt>
            <span id="forCredit">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillPayment.forCredit">For Credit</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillPaymentEntity.forCredit ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillPayment.refundBill">Refund Bill</Translate>
          </dt>
          <dd>{pharmacyReturnBillPaymentEntity.refundBill ? pharmacyReturnBillPaymentEntity.refundBill.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-return-bill-payment" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-return-bill-payment/${pharmacyReturnBillPaymentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyReturnBillPaymentDetail;
